import { render, staticRenderFns } from "./TableSpecialCareList.vue?vue&type=template&id=1936e153&scoped=true"
import script from "./TableSpecialCareList.vue?vue&type=script&lang=js"
export * from "./TableSpecialCareList.vue?vue&type=script&lang=js"
import style0 from "./TableSpecialCareList.vue?vue&type=style&index=0&id=1936e153&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1936e153",
  null
  
)

export default component.exports